export default __webpack_public_path__ + "static/media/2_0156.816e2129.webp";